module.exports = __webpack_public_path__ + "static/media/2025_Nuna_Law.2ceb4812.png";